import { NavigationItem } from "@/domains/navigation/navigation-item"
import { ActiveStateStartsWithStrategy } from "@/domains/navigation/strategies/active-state-starts-with-strategy"
import { DynamicURLStrategy } from "@/domains/navigation/strategies/dynamic-url-strategy"
import { ClassicLiquiditySubItem } from "@/domains/navigation/subitems/classic-liquidity-subitem"
import { ClFarmsLiquiditySubItem } from "@/domains/navigation/subitems/clfarms-liquidity-subitem"
import { ManualClLiquiditySubItem } from "@/domains/navigation/subitems/manualcl-liquidity-subitem"
import { ManualClV2LiquiditySubItem } from "@/domains/navigation/subitems/manualcl-v2-liquidity-subitem"
import {
  LiquidityAddTab,
  LiquidityOverviewTab,
  LiquidityStakeTab,
  LiquidityWithdrawTab,
} from "@/domains/navigation/tabs/liquidity-tabs"

import { ActiveStateStartsWithFilteredStrategy } from "../strategies/active-state-starts-with-filtered-strategy"

export class LiquidityNavigationItem extends NavigationItem {
  readonly id = "liquidity"
  readonly label = "Liquidity"
  readonly href = "/liquidity"
  readonly iconName = "liquidity-icon"
  readonly isExternal = false

  readonly tabs = [
    new LiquidityOverviewTab(),
    new LiquidityAddTab(),
    new LiquidityStakeTab(),
    new LiquidityWithdrawTab(),
  ]

  readonly subItems = [
    new ClassicLiquiditySubItem(),
    new ClFarmsLiquiditySubItem(),
    new ManualClLiquiditySubItem(),
    new ManualClV2LiquiditySubItem(),
  ]

  constructor() {
    super()
    // Set active strategies for sub-items
    // subItems[0] already has exact match by default
    this.subItems[0]?.setActiveStrategy(
      new ActiveStateStartsWithFilteredStrategy("/liquidity", ["/liquidity/cl-farms", "/liquidity/cl"]),
    )
    this.subItems[1]?.setActiveStrategy(new ActiveStateStartsWithStrategy("/liquidity/cl-farms"))
    this.subItems[2]?.setActiveStrategy(new ActiveStateStartsWithStrategy("/liquidity/cl/v1"))
    this.subItems[3]?.setActiveStrategy(new ActiveStateStartsWithStrategy("/liquidity/cl/v2"))

    // Set URL strategy for dynamic address handling
    this.setURLStrategy(new DynamicURLStrategy())
  }
}
